import { useTranslation } from 'react-i18next'

import youreNotAloneFemalePNG from '~/assets/images/anatomyV2/you-re-not-alone-female.png'
import youreNotAloneFemaleWEBP from '~/assets/images/anatomyV2/you-re-not-alone-female.webp'
import youreNotAloneMalePNG from '~/assets/images/anatomyV2/you-re-not-alone-male.png'
import youreNotAloneMaleWEBP from '~/assets/images/anatomyV2/you-re-not-alone-male.webp'
import InfoRevealTemplate from '~/pages/anatomyV2/libs/components/InfoRevealTemplate'
import { useBulkSelector } from '~/shared/hooks/useBulkSelector'
import { selectAnswers } from '~/shared/store/common/selects'
import { TPageProps } from '~/shared/types/commonTypes'

const SECTION_NUMBER = 6

const GENDER_I18N_MAP: Record<string, string> = {
  male: 'onboarding.youreNotAlone.gender.male',
  female: 'onboarding.youreNotAlone.gender.female',
  other: 'onboarding.youreNotAlone.gender.other',
}

const YoureNotAloneAnatomyV2 = (props: TPageProps) => {
  const { t } = useTranslation('anatomyV2')
  const { user } = useBulkSelector({ user: selectAnswers })

  const genderKey = String(user?.['gender-1'] ?? 'female')

  const isMale = genderKey === 'male'
  const genderText = t(GENDER_I18N_MAP[genderKey] ?? GENDER_I18N_MAP.female)

  return (
    <InfoRevealTemplate
      {...props}
      buttonI18nKey="onboarding.youreNotAlone.button"
      buttonNs="anatomyV2"
      currentSection={SECTION_NUMBER}
      imageAlt="You're not alone"
      imagePNG={isMale ? youreNotAloneMalePNG : youreNotAloneFemalePNG}
      imageWEBP={isMale ? youreNotAloneMaleWEBP : youreNotAloneFemaleWEBP}
      paragraphI18nKeys={['onboarding.youreNotAlone.paragraph']}
      paragraphValues={{ genderText }}
      question="You're not alone viewed"
      titleI18nKey="onboarding.youreNotAlone.title"
    />
  )
}

export default YoureNotAloneAnatomyV2
